import * as yup from 'yup';

export default function detailsArray(key, field, value) {
  return yup.array().nullable().when(key, { is: value, then: field });
}
